import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh]">
      <h1 className="text-6xl font-bold text-gray-300 dark:text-gray-700 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-4">Không Tìm Thấy Trang</h2>
      <p className="text-gray-600 dark:text-gray-400 mb-8">
        Trang bạn đang tìm kiếm không tồn tại.
      </p>
      <Link to="/" className="btn-primary">
        Về Trang Chủ
      </Link>
    </div>
  );
}

export default NotFound;
